export const FB_REGISTRATION = 'facebook-registration';

export const FB_PARAMS_TO_REMOVE = [
    'code',
    'state',
    'error',
    'error_code',
    'error_reason',
    'error_message',
    'error_description'
];
